import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { POSTGetInitiateReportServices } from "../../../../../../service/POSTGetInitiateReportServices";
import {
  INITIATE_DROPDOWN_REPORT_TRIP,
  DROPDOWN_REPORT_TRIP,
} from "../../../../../../api/contractAPI.api";
import { POSTGetListReportServices } from "../../../../../../service/POSTGetListReport";
import { Checkbox, Input } from "antd";
import { IconSearch } from "../../../../../../asset";
import { setGlobalTrip } from "../../../../../../store/reducer/globalMultipleSearchSelect.reducer";

const MSSReportTrip = ({
  children,
  togglerClassName,
  placeholder,
  className,
  ...attrs
}) => {
  const dispatch = useDispatch();

  const { token } = useSelector((state) => state.auth);
  const { globalDepotName } = useSelector((state) => state.globalMSS);
  const { valuesMultipleSelectTripStatus } = useSelector(
    (state) => state.globalMultipleSelectValues
  );

  const dropdownRef = useRef(null);
  const dropdownContentRef = useRef(null);
  const btnDropdownRef = useRef(null);
  const [isShowDropdownContent, setIsShowDropdownContent] = useState(false);
  const [listData, setListData] = useState([]);
  const [listSelected, setListSelected] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [totalData, setTotalData] = useState(null);
  const [isSelectedAll, setIsSelectedAll] = useState(false);
  const [params, setParams] = useState();

  const [bodyRequest, setBodyRequest] = useState();

  const togglerDropdownContent = useCallback(() => {
    setIsShowDropdownContent((state) => !state);
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      if (
        dropdownRef?.current &&
        !dropdownRef?.current.contains(event?.target) &&
        dropdownContentRef?.current?.classList.contains("active")
      ) {
        setIsShowDropdownContent(false);
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document?.removeEventListener("click", handleClick);
    };
  }, []);

  const isDepotHasValue = useMemo(() => {
    if (globalDepotName && globalDepotName.length === 0) {
      return false;
    }
    return true;
  }, [globalDepotName]);

  const isTripStatusHasValue = useMemo(() => {
    if (
      valuesMultipleSelectTripStatus &&
      valuesMultipleSelectTripStatus.length === 0
    ) {
      return false;
    }
    return true;
  }, [valuesMultipleSelectTripStatus]);

  const isEnabledTrip = useMemo(() => {
    if (isDepotHasValue && isTripStatusHasValue) {
      return true;
    }
    return false;
  }, [isDepotHasValue, isTripStatusHasValue]);

  const getTotalData = useCallback(
    async (payload) => {
      const resInitiate = await POSTGetInitiateReportServices(
        token,
        INITIATE_DROPDOWN_REPORT_TRIP,
        payload
      );

      if (resInitiate?.success && resInitiate?.initiate) {
        setTotalData(resInitiate?.initiate?.count_data);
      }
    },
    [token]
  );

  const getTripList = useCallback(
    async (payload) => {
      const res = await POSTGetListReportServices(
        token,
        DROPDOWN_REPORT_TRIP,
        payload
      );
      if (res?.success && res?.list !== null) {
        const list = res?.list.map((el) => {
          return {
            id: el?.id,
            name: el?.trip_name,
          };
        });

        if (payload?.filter && payload?.filter.includes("trip_name")) {
          setListData([...list]);
          return;
        }
        list.unshift({ id: -1, name: "Select All" });
        setListData([...list]);
      }
      if (res?.success && res?.list === null) {
        setListData([{ id: -1, name: "Select All" }]);
      }
    },
    [token]
  );

  useEffect(() => {
    if (isEnabledTrip) {
      const depots = [...globalDepotName];
      const depotListId =
        depots && depots.includes(-1)
          ? {
              depot: { list_id: [-1], exclude: false },
            }
          : {
              depot: {
                list_id: depots.map((el) => el?.id),
                exclude: false,
              },
            };

      const tripStatus = [...valuesMultipleSelectTripStatus];
      const tripStatusList =
        tripStatus && tripStatus.includes(-1)
          ? {
              trip_status: { list: ["ALL"], exclude: false },
            }
          : {
              trip_status: {
                list: tripStatus.map((el) => el?.id),
                exclude: false,
              },
            };

      const bodyReq = {
        page: 1,
        limit: 10,
        order: "",
        filter: "",
        connector: "",
        other: {
          ...depotListId,
          ...tripStatusList,
        },
      };

      getTotalData(bodyReq);
      getTripList(bodyReq);
      setBodyRequest(bodyReq);
    }
  }, [
    getTotalData,
    getTripList,
    globalDepotName,
    isDepotHasValue,
    isEnabledTrip,
    valuesMultipleSelectTripStatus,
  ]);

  const handleClickSelectData = useCallback(
    (item) => {
      if (item?.id === -1) {
        if (listSelected.length === 0 || !listSelected) {
          setListSelected([-1]);
          dispatch(setGlobalTrip([-1]));
          return;
        }
        if (listSelected.length && listSelected.length - 1 !== totalData) {
          if (listSelected.includes(-1)) {
            setListSelected([]);
            dispatch(setGlobalTrip([]));
            return;
          }
          setListSelected([-1]);
          dispatch(setGlobalTrip([-1]));
          return;
        }
        if (listSelected.length && listSelected.includes(-1)) {
          setListSelected([]);
          dispatch(setGlobalTrip([]));
        }

        return;
      }
      if (item?.id !== -1) {
        if (listSelected.length === 0) {
          const listDataSelected = listSelected;
          listDataSelected.push(item);
          setListSelected([...listDataSelected]);
          dispatch(setGlobalTrip([...listDataSelected]));
          return;
        }
        const isAllSelected = listSelected.includes(-1);

        if (isAllSelected) {
          const idFiltering = [-1];
          idFiltering.push(item?.id);
          const newList = listData.filter(
            (el) => !idFiltering.includes(el?.id)
          );
          setListSelected([...newList]);
          dispatch(setGlobalTrip([...newList]));
          return;
        }
        const isExist = listSelected.some((el) => el?.id === item?.id);
        if (isExist) {
          const listDataFiltered = listSelected.filter(
            (el) => el?.id !== item?.id
          );
          setListSelected([...listDataFiltered]);
          dispatch(setGlobalTrip([...listDataFiltered]));
          return;
        } else {
          const list = listSelected;
          list.unshift(item);
          setListSelected([...list]);
          dispatch(setGlobalTrip([...list]));
          return;
        }
      }
    },
    [dispatch, listData, listSelected, totalData]
  );

  const isCheckedSelectAll = useMemo(() => {
    if (listSelected !== undefined && listSelected.length === totalData) {
      setIsSelectedAll(true);
      return true;
    }
    setIsSelectedAll(false);
    return false;
  }, [listSelected, totalData]);

  const isCheckedPerItem = useCallback(
    (item) => {
      if (listSelected.length > 0) {
        if (listSelected.length === totalData || listSelected.includes(-1)) {
          return true;
        }
        const isExist = listSelected.some((el) => el.id === item.id);
        return isExist;
      }
      return false;
    },
    [listSelected, totalData]
  );

  const isAllDepot = useMemo(() => {
    if (listSelected.length) {
      if (listSelected.includes(-1)) {
        return true;
      }
      const length = listSelected.length;
      if (listSelected.length > 0 && length === totalData) {
        return true;
      }
    }
    return false;
  }, [listSelected, totalData]);

  const onChangeSearch = useCallback((val) => {
    setSearchKeyword(val);
  }, []);

  useEffect(() => {
    if (isEnabledTrip) {
      if (!searchKeyword) {
        const resetParams = {
          ...bodyRequest,
          page: 1,
          limit: 10,
          filter: "",
        };
        getTripList(resetParams);
        return;
      }
      const newParams = {
        ...bodyRequest,
        page: 1,
        limit: 10,
        filter: `trip_name lk ${searchKeyword}`,
      };
      getTripList(newParams);
    }
    return;
  }, [bodyRequest, getTripList, isDepotHasValue, isEnabledTrip, searchKeyword]);

  return (
    <div
      className={"dropdown-dds".concat(className ? ` ${className}` : "")}
      {...attrs}
      ref={dropdownRef}
    >
      <button
        className={`${
          isEnabledTrip ? "value-mss" : " value-mss-disabled"
        } `.concat(!isEnabledTrip ? " cursor-not-allowed" : "")}
        onClick={isEnabledTrip ? togglerDropdownContent : undefined}
        ref={btnDropdownRef}
      >
        {isAllDepot ? (
          <span className="list-value-mss">All Trip </span>
        ) : isCheckedSelectAll === false && listSelected.length !== 0 ? (
          listSelected.map((item, index) => (
            <span key={index} className="list-value-mss">
              {item?.name}
            </span>
          ))
        ) : (
          <span className="placeholder-mss">Select Trip</span>
        )}
      </button>
      {!isEnabledTrip ? (
        <span className="font-roboto text-xs font-semibold text-red-100 mt-2">
          * Select Depot and Trip Status first
        </span>
      ) : (
        false
      )}
      <div></div>
      <div
        className={"dropdown-dds-menu".concat(
          isShowDropdownContent ? " active mt-2 pb-10" : ""
        )}
        ref={dropdownContentRef}
      >
        <div className="my-2 px-2">
          <Input
            placeholder="Search By Trip Name"
            size="large"
            suffix={<img src={IconSearch} alt="icon-search" />}
            onChange={(evt) => onChangeSearch(evt.target.value)}
          />
        </div>
        <div className="overflow-auto max-h-[300px]">
          {listData?.map((el, index) => (
            <div
              key={index}
              className={"dropdown-dds-item truncate"}
              onClick={() => handleClickSelectData(el)}
            >
              <div className="w-full flex justify-between px-2">
                <span>{el?.name}</span>
                <Checkbox checked={isCheckedPerItem(el)} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MSSReportTrip;
